// import dayjs from 'dayjs';
import * as Config from '../config';
import { useEffect } from "react";
import { useDispatch } from 'react-redux';

import {
  // setAuthResponse, 
  setConnect, setSubscription, setLayoutTablet, setSplashState,
} from "../actions/index";

import {
  setOutsiderPM
} from "../components/library/partymode/redux/actions/index";

import useStoreApi from "./useStoreApi";

const axios = require('axios');
const querystring = require('querystring');

// Store API LINK Management
let lock = false;
const useApi = (auth) => {
  const dispatch = useDispatch();
  const { prepareStore, initApp } = useStoreApi();

  useEffect(() => {
    let code = (auth && auth.code) ? auth.code : null;

    if (!code) {
      const source = Config.API_NAME;
      const userid = localStorage.getItem('cQfdJ@gD8yjHqr');
      axios.post(`${Config.AUTH_DJAPP_URL}/auth-v2.php`, querystring.stringify({ source, userid }), { headers: { 'content-type': 'application/x-www-form-urlencoded; charset=utf-8' } }).then( r => {
        const token = r.data;
        if (!token.anonymous) {
          // console.log('EXISTING TOKKEN')
          const store = prepareStore({ access_token: token.access_token });
          initApp(store);

          // REFRESH TOKEN
          setInterval(() => {
            axios.post(`${Config.AUTH_DJAPP_URL}/auth-refresh-v2.php`, querystring.stringify({ source, userid  }), { headers: { 'content-type': 'application/x-www-form-urlencoded; charset=utf-8' } }).then( response => {
              const token = (response.data) ? response.data : null;
              // console.log('REFRESH TOKKEN', token)
              if (token && token.success) { store.setToken(token) };
            })
          }, 180000) // 3min; 

        } else {
          // no Connected + no Subscribed : New Or Basic User
          // console.log('NO EXISTING TOKKEN - ANONYMOUS')
          const store = prepareStore({ access_token: token.access_token });

          // REFRESH TOKEN
          setInterval(() => {
            axios.post(`${Config.AUTH_DJAPP_URL}/auth-v2.php`, querystring.stringify({ source, userid }), { headers: { 'content-type': 'application/x-www-form-urlencoded; charset=utf-8' } }).then( r => {
              const token = r.data;
              if (token) { store.setToken(token) };
            })
          }, 3600000 * 9) // 9h;

          dispatch(setSubscription(false));
          dispatch(setConnect(false));
          dispatch(setOutsiderPM(true));
          lock = false;
          localStorage.removeItem('a5RAW%93W!gph8'); // PM
          (window['YouDJ'] && window['YouDJ'].logout) && window['YouDJ'].logout();
          if (!Config.FREEMIUM) {
            (window['window_resize']) && window['window_resize']();
          }
          dispatch(setLayoutTablet(false));
          dispatch(setSplashState(false)); // PLAYER + LIBRARY -> READY
        }
      }).catch(e => console.log(e));
    } else if (code && !lock) {
      lock = true;
      const source = Config.API_NAME;
      const uri = (window.location.origin.includes('localhost')) ? `${window.location.origin}/` : (window.location.pathname.includes('new-account') ? `${window.location.origin}/new-account` : `${window.location.origin}/home`) ;
      axios.post(`${Config.AUTH_DJAPP_URL}/auth-code-v2.php`, querystring.stringify({ code, uri, source }), { headers: { 'content-type': 'application/x-www-form-urlencoded; charset=utf-8' } }).then( response => {
        const token = (response.data) ? response.data : null;
        // console.log('NEW TOKKEN WITH CODE', token) 
        // initApp(prepareStore(token), true);

        if (token && token.success && token.userid) {
          localStorage.setItem('cQfdJ@gD8yjHqr', token.userid);
          const lastPage = localStorage.getItem('LVP');
          if (Config.IFRAME) {
            window.location.href = `${window.location.origin}/view/play`;
          } else {
            window.location.href = (lastPage) ? `${window.location.origin}${lastPage}` : `${window.location.origin}/home`;
          }
        }

      }).catch( e => {
        console.log('ERROR CONNECT !!!!')
        // dispatch(setAuthResponse(false));
        // if (!stateConnect && !isRefresh) { // NOK - Player & Library state not sync
        //   console.log('ERROR', e)
        //   dispatch(setSplashError({ title: 'Info', message: `The DJ App is currently undergoing maintenance. Thank you for your patience.` }));
        // }
      });
    }
     
  }, [auth, dispatch, prepareStore, initApp]);

  return null;
};

export default useApi;
